import { gql } from '@apollo/client';

export const ALL_DISABILITY_TYPES = gql`
  query AllDisabilityTypes {
    disabilityTypes: allDisabilityTypes {
      id
      name
    }
  }
`;
